export default "__VITE_ASSET__3a323428__"